import { configureStore } from '@reduxjs/toolkit';
import loadingReducer from './slices/loadingSlice';
import loginReducer from './slices/loginSlice'
import toastReducer from './slices/toastSlice'
import userReducer from './slices/userSlice'

 const store = configureStore({
  reducer: {
    loading: loadingReducer,
    login : loginReducer,
    toast : toastReducer,
    user: userReducer
  },
});
export  default store